module.exports = __webpack_public_path__ + "static/media/statsScreen.2dab657b.jpg";